export const generalStyles = {
  borderTopRightLeftRadius: {
    borderTopRightRadius: '6px',
    borderTopLeftRadius: '6px',
  },
  borderTopNone: {
    borderTop: 'none',
  },
  borderBottomLeftRightRadius: {
    borderBottomRightRadius: '6px',
    borderBottomLeftRadius: '6px',
  },
  borderRadiusAll: {
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
    borderBottomRightRadius: '6px',
    borderBottomLeftRadius: '6px',
  },
  leftSingleContainer: {
    height: '58px',
    minWidth: '192px',
    '& .MuiTypography-root': {
      fontSize: '16px',
    },
  },
  rightSingleContainer: {
    height: '58px',
    '& .MuiOutlinedInput-root': {
      height: '58px',
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      boxShadow: 'none',
    },
    '& .MuiTypography-root': {
      fontSize: '16px',
    },
  },
  leftSingleContainerWithUnBottomRadius: {
    height: '58px',
    minWidth: '192px',
    borderBottomLeftRadius: 'none',
    '& .MuiTypography-root': {
      fontSize: '16px',
    },
  },
  rightSingleContainerUnBottomRadius: {
    height: '58px',
    borderBottomRightRadius: 'none',
    '& .MuiOutlinedInput-root': {
      height: '58px',
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      boxShadow: 'none',
    },
    '& .MuiTypography-root': {
      fontSize: '16px',
    },
  },
  leftSingleContainerWithUnTopRadius: {
    height: '58px',
    minWidth: '192px',
    borderTopLeftRadius: 'none',
    '& .MuiTypography-root': {
      fontSize: '16px',
    },
  },
  rightSingleContainerUnTopRadius: {
    height: '58px',
    borderTopRightRadius: 'none',
    '& .MuiOutlinedInput-root': {
      height: '58px',
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      boxShadow: 'none',
    },
    '& .MuiTypography-root': {
      fontSize: '16px',
    },
  },
  borderTopLeftRadius: {
    borderTopLeftRadius: '6px',
  },
  borderTopRightRadius: {
    borderTopRightRadius: '6px',
  },
  borderBottomLeftRadius: {
    borderBottomLeftRadius: '6px',
  },
  borderBottomRightRadius: {
    borderBottomRightRadius: '6px',
  },
  borderTopBottomLeftRadius: {
    borderTopLeftRadius: '6px',
    borderBottomLeftRadius: '6px',
  },
  borderTopBottomRightRadius: {
    borderTopRightRadius: '6px',
    borderBottomRightRadius: '6px',
  },
  marginTopBotOne: {
    margin: '-1px 0 -1px 0',
  },
  inputBase: {
    ml: 2,
    flex: 1,
    fontSize: '14px',
  },
  customCalendarMarginTop: {
    marginTop: '24px',
  },
};
